/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WizardPlanTaskDto } from './WizardPlanTaskDto';
import {
    WizardPlanTaskDtoFromJSON,
    WizardPlanTaskDtoFromJSONTyped,
    WizardPlanTaskDtoToJSON,
    WizardPlanTaskDtoToJSONTyped,
} from './WizardPlanTaskDto';
import type { WizardPlanAssignmentDto } from './WizardPlanAssignmentDto';
import {
    WizardPlanAssignmentDtoFromJSON,
    WizardPlanAssignmentDtoFromJSONTyped,
    WizardPlanAssignmentDtoToJSON,
    WizardPlanAssignmentDtoToJSONTyped,
} from './WizardPlanAssignmentDto';

/**
 * 
 * @export
 * @interface PreviewPlanFromWizardRequestDto
 */
export interface PreviewPlanFromWizardRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PreviewPlanFromWizardRequestDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewPlanFromWizardRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewPlanFromWizardRequestDto
     */
    priority?: PreviewPlanFromWizardRequestDtoPriorityEnum;
    /**
     * Days ahead of due date when ticket generation may create a Preventive Ticket (default 90)
     * @type {number}
     * @memberof PreviewPlanFromWizardRequestDto
     */
    schedulingHorizonDays?: number;
    /**
     * 
     * @type {Array<WizardPlanTaskDto>}
     * @memberof PreviewPlanFromWizardRequestDto
     */
    tasks: Array<WizardPlanTaskDto>;
    /**
     * 
     * @type {WizardPlanAssignmentDto}
     * @memberof PreviewPlanFromWizardRequestDto
     */
    assign?: WizardPlanAssignmentDto;
}


/**
 * @export
 */
export const PreviewPlanFromWizardRequestDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type PreviewPlanFromWizardRequestDtoPriorityEnum = typeof PreviewPlanFromWizardRequestDtoPriorityEnum[keyof typeof PreviewPlanFromWizardRequestDtoPriorityEnum];


/**
 * Check if a given object implements the PreviewPlanFromWizardRequestDto interface.
 */
export function instanceOfPreviewPlanFromWizardRequestDto(value: object): value is PreviewPlanFromWizardRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tasks' in value) || value['tasks'] === undefined) return false;
    return true;
}

export function PreviewPlanFromWizardRequestDtoFromJSON(json: any): PreviewPlanFromWizardRequestDto {
    return PreviewPlanFromWizardRequestDtoFromJSONTyped(json, false);
}

export function PreviewPlanFromWizardRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreviewPlanFromWizardRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'schedulingHorizonDays': json['schedulingHorizonDays'] == null ? undefined : json['schedulingHorizonDays'],
        'tasks': ((json['tasks'] as Array<any>).map(WizardPlanTaskDtoFromJSON)),
        'assign': json['assign'] == null ? undefined : WizardPlanAssignmentDtoFromJSON(json['assign']),
    };
}

export function PreviewPlanFromWizardRequestDtoToJSON(json: any): PreviewPlanFromWizardRequestDto {
    return PreviewPlanFromWizardRequestDtoToJSONTyped(json, false);
}

export function PreviewPlanFromWizardRequestDtoToJSONTyped(value?: PreviewPlanFromWizardRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'priority': value['priority'],
        'schedulingHorizonDays': value['schedulingHorizonDays'],
        'tasks': ((value['tasks'] as Array<any>).map(WizardPlanTaskDtoToJSON)),
        'assign': WizardPlanAssignmentDtoToJSON(value['assign']),
    };
}

